import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Fire from "../api/Fire";
import CartContext from "../contexts/cart";
import Dialog from "./Dialog";

const Product = ({ item, onClick }) => {
  const { t } = useTranslation();
  const [quantity, setQuantity] = useState(1);
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState(1);
  const { cart } = useContext(CartContext);

  const _addToCart = async () => {
    if (!Fire.currentUser) {
      setMessage(t("noUser"));
      setType(2);
      setVisible(true);
      return;
    }

    let list = [...cart];
    let i = { id: item.id, quantity: quantity, type: item.description ? "basket" : "product" };

    if (list.some((obj) => obj.id === item.id)) {
      let objIndex = list.findIndex((obj) => obj.id === item.id);
      list[objIndex] = i;
    } else {
      list = [...list, i];
      document.getElementById(t("language") === "en" ? "menu" : "menu-en").style.width = "350px";
      document.getElementById(t("language") === "en" ? "menu" : "menu-en").style.paddingInline = "10px";
    }
    await Fire._updateCart({ items: list });
  };

  const _renderOptions = () => {
    let arr = [...Array(item.quantity)];

    return (
      <div className="d-flex justify-content-end align-items-center">
        <button className="btn btn-success py-1 mx-1" onClick={_addToCart}>
          <FontAwesomeIcon icon={faPlus} size="lg" color="fff" />
        </button>
        <select
          className="form-select bg-light border-0"
          onChange={(event) => setQuantity(parseFloat(event.target.value))}
          value={quantity}
        >
          {item.type === "kilos"
            ? arr.map((x, i) => {
                return (
                  <React.Fragment key={i}>
                    <option key={i} value={i + 1}>
                      {i + 1} KG
                    </option>
                    {i < arr.length - 1 ? (
                      <option key={i + 1} value={i + 1.5}>
                        {i + 1.5} KG
                      </option>
                    ) : null}
                  </React.Fragment>
                );
              })
            : arr.map((x, i) => {
                return (
                  <option key={i} value={i + 1}>
                    {i + 1}
                  </option>
                );
              })}
        </select>
      </div>
    );
  };

  return (
    <div className="product text-center">
      <div onClick={onClick} className="flex-fill">
        {/* Sale Badge */}
        {item.sale && new Date() < new Date(item.saleEnd) ? (
          <div className="badge-overlay">
            <span className="top-left badge orange">{item.sale} %</span>
          </div>
        ) : null}
        {/* Sale Badge */}

        <div className="mb-3">
          <img src={item.image || item.thumbnail} alt={item.nameEn} height={70} width={70} />
        </div>

        <div className="my-2">{t("language") === "en" ? item.name : item.nameEn}</div>

        {item.sale && new Date() < new Date(item.saleEnd) ? (
          <div className="my-2">
            <del>
              {item.price}
              <span className="text-muted mx-1" style={{ fontSize: 12 }}>
                {t("SAR")}
              </span>
            </del>

            <div>
              <span className="text-danger">{item.price - item.price * (item.sale / 100)} </span>
              <span className="text-muted mx-1" style={{ fontSize: 12 }}>
                {t("SAR")}
              </span>
            </div>
          </div>
        ) : (
          <div className="my-2">
            <span>{item.price}</span>
            <span className="text-muted mx-1" style={{ fontSize: 12 }}>
              {t("SAR")}
            </span>
          </div>
        )}
      </div>

      {_renderOptions()}

      <Dialog visible={visible} onHide={() => setVisible(false)} message={message} type={type} />
    </div>
  );
};

export default Product;
